import React from "react";
import profilepic from "../asset/profile-pic.jpeg";

const Hero = () => {
  return (
    <section className="section-shell bg-primary px-5 pb-20 pt-28 text-white md:px-8 md:pt-36" id="home">
      <div className="absolute -left-16 top-24 h-72 w-72 rounded-full bg-cyan-400/15 blur-3xl" />
      <div className="absolute -right-12 top-44 h-64 w-64 rounded-full bg-teal-300/10 blur-3xl" />

      <div className="relative z-10 mx-auto grid w-full max-w-6xl gap-10 md:grid-cols-[1.35fr_0.9fr] md:items-center">
        <div className="reveal-up reveal-delay-1">
          <p className="section-kicker mb-4">Cloud and Platform Engineering</p>
          <h1 className="heading-font section-title text-4xl font-bold leading-tight sm:text-5xl md:text-6xl">
            Jeffrey Lau
          </h1>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg">
            I build secure cloud platforms and automation-first delivery pipelines that help teams ship faster,
            govern better, and run resilient infrastructure at scale.
          </p>
          <div className="mt-8 flex flex-col gap-4 sm:flex-row sm:items-center">
            <a
              href="/#contact"
              className="heading-font inline-flex items-center justify-center rounded-lg bg-accent px-6 py-3 text-sm font-semibold uppercase tracking-wider text-slate-900 shadow-lg shadow-teal-600/25 transition hover:-translate-y-0.5 hover:bg-teal-300"
            >
              Let&apos;s Connect
            </a>
            <a
              href="https://www.linkedin.com/in/jeffrey-ck-lau/"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center rounded-lg border border-slate-400/40 px-6 py-3 text-sm font-semibold uppercase tracking-wider text-slate-100 transition hover:border-accent hover:text-accent"
            >
              LinkedIn Profile
            </a>
          </div>
        </div>

        <div className="reveal-up reveal-delay-2 mx-auto w-full max-w-sm">
          <div className="glass-panel rounded-3xl p-5">
            <img
              className="h-72 w-full rounded-2xl object-cover object-center ring-1 ring-white/20 md:h-80"
              src={profilepic}
              alt="Jeffrey Lau"
            />
            <div className="mt-4 rounded-xl bg-slate-900/40 p-4">
              <p className="text-xs font-semibold uppercase tracking-[0.14em] text-teal-300">Current Focus</p>
              <p className="mt-2 text-sm text-slate-300">Platform security, cloud governance, and AI-driven operations.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
